module.exports = __webpack_public_path__ + "img/member-banner.b2fb5762.jpg";